'use strict';
import {projectFileRequirementStates} from '../requirements/router-config';
import {TaskType} from './enums/TaskType';
import activityFeedTemplate from './ngTemplates/project-tasks-activity-feed.html';
import requirementsTemplate from './ngTemplates/project-tasks-requirements.html';
import timerLogTemplate from './ngTemplates/project-tasks-timer-log.html';
import {projectTasksStates} from './router-config';
import {TASK_STATE_HELPER} from './TASK_STATE_HELPER';


export const projectTasksCtrlConfig = {
  taskType: TaskType.PROJECT,
  modelDomain: 'TaskDomain',
  taskListState: projectTasksStates.tasks,
  taskDetailsState: projectTasksStates.requirements,
};

routerProjectsTasksProvider.$inject = [
  '$stateProvider',
];

export function routerProjectsTasksProvider($stateProvider) {
  $stateProvider
    .state(projectTasksStates.requirements, {
      title: 'tasks.views.requirements.title',
      url: '/tasks/:taskId/requirements',
      views: {
        'tab-projects-tasks': {
          template: requirementsTemplate,
          controller: 'TasksDetailsController as taskDetails',
        },
      },
      params: {
        requirementType: null,
      },
      resolve: {
        requirementType: TASK_STATE_HELPER.resolveRequirementType,
        task: TASK_STATE_HELPER.createResolveTask('TaskDomain', projectTasksStates.tasks),
        ctrlConfig: () => Object.assign({
          fileUploadState: projectFileRequirementStates.details,
        }, projectTasksCtrlConfig),
      },
    })

    .state(projectTasksStates.activityFeed, {
      title: 'tasks.views.activity.title',
      url: '/tasks/:taskId/activity-feed',
      views: {
        'tab-projects-tasks': {
          template: activityFeedTemplate,
        },
      },
      resolve: {
        ctrlConfig: () => projectTasksCtrlConfig,
      },
    })

    .state(projectTasksStates.timerLog, {
      title: 'tasks.views.timer.title',
      url: '/tasks/:taskId/timer-log',
      views: {
        'tab-projects-tasks': {
          template: timerLogTemplate,
        },
      },
      resolve: {
        ctrlConfig: () => projectTasksCtrlConfig,
      },
    });
}



// WEBPACK FOOTER //
// ./src/js/tasks/router-project-tasks.js